import React from 'react'

import { type Question } from '~/hooks/useSurveyQuery'

import { useNormalAnswersData } from '../hooks/useNormalAnswersData'
import { getAnswerOptionRowId } from '../utils'

import { IndividualChart, type IndividualChartProps } from './IndividualChart'

export type IndividualQuestionChartProps = {
  question: Question
}

export const IndividualQuestionChart = ({
  question,
}: IndividualQuestionChartProps) => {
  const answersData = useNormalAnswersData(question)
  const individualChartProps = React.useMemo<
    IndividualChartProps<(typeof answersData)[number]>
  >(
    () => ({
      getChartCategoryAxisItemLabel: (value) => {
        const [option, text] = value.split('.')
        const truncatedText = 7 < text.length ? `${text.slice(0, 6)}...` : text

        return `${option}.${truncatedText}`
      },
      getName: ({ answerOption }) =>
        `${answerOption.option}. ${answerOption.text}`,
      getRowId: (answerData) =>
        getAnswerOptionRowId(answerData.question, answerData.answerOption),
      id: question.question_id,
      rowsData: answersData,
    }),
    [answersData, question.question_id],
  )

  return <IndividualChart {...individualChartProps} />
}
